import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'deviceType'
})
export class DeviceTypePipe implements PipeTransform {
  constructor(private _translocoService:TranslocoService){}
  transform(userAgent: string): string {
    const devicePatterns = [
      { regex: /Macintosh/, type: this._translocoService.translate("Log for device type (Device type log) - Desktop") },
      { regex: /Windows/, type: this._translocoService.translate("Log for device type (Device type log) - Desktop") },
      { regex: /iPhone/, type: this._translocoService.translate("Log for device type (Device type log) - Mobile") },
      { regex: /iPad/, type: this._translocoService.translate("Log for device type (Device type log) - Tablet") },
      { regex: /Android/, type: this._translocoService.translate("Log for device type (Device type log) - Mobile") },
      { regex: /Linux/, type: this._translocoService.translate("Log for device type (Device type log) - Desktop") }
    ];

    for (const pattern of devicePatterns) {
      if (pattern.regex.test(userAgent)) {
        return pattern.type;
      }
    }

    return this._translocoService.translate("Log for device type (Device type log) - Unknown Device");
  }
}